export default "__VITE_ASSET__C8XHjOZ2__"